'use client';

import React from 'react';
import {useTracker, TrackImpression} from '@udemy-v2/event-tracking';
import {useI18n} from '@udemy-v2/i18n';

import {
    createTestimonialImpressionEvent,
    createUFBNoticeImpressionEvent,
} from '../../data/tracking';

interface TestimonialCardImpressionProps {
    /** Stable tracking id for the testimonial group (TestimonialsGroup.trackingId). */
    id: string;
    /** Mapped event type (e.g. 'case-study'), from the CMS labelText. */
    type: string;
    url: string;
    /** Whether this testimonial is a case study (fires an extra UFB notice event). */
    isCaseStudy: boolean;
    children: React.ReactNode;
}

/**
 * Client wrapper that publishes a `TestimonialImpressionEvent` when a testimonial
 * card scrolls into view, mirroring v1's `LearningTestimonialCard`. Case-study
 * testimonials also publish a `UFBNoticeImpressionEvent`.
 */
export const TestimonialCardImpression: React.FC<TestimonialCardImpressionProps> = ({
    id,
    type,
    url,
    isCaseStudy,
    children,
}) => {
    const tracker = useTracker();
    const {locale} = useI18n();

    return (
        <TrackImpression
            trackFunc={() => {
                tracker.publishEvent(
                    createTestimonialImpressionEvent({id, type, uiRegion: 'body'}),
                );
                if (isCaseStudy) {
                    tracker.publishEvent(
                        createUFBNoticeImpressionEvent({url, placement: 'body', locale}),
                    );
                }
            }}
        >
            {children}
        </TrackImpression>
    );
};
